import Api from "../common/Api";
import { BzkndModel } from "app/model/common/bzkndModel";
import {ActvLogDateModel, ActvLogModel, ActvLogSaveModel} from "app/model/common/actvLogModel";
import { KepcoCustInfos, KepcoUserData } from "app/model/sysUser/kepcoCustModel";

export class CoService extends Api {
  private static service: CoService;

  public static getInstance(): CoService{
    if (!CoService.service) {
      CoService.service = new CoService();
    }
    return CoService.service;
  }

  public async getBzkndList() {
    const url = process.env.REACT_APP_URL_CO + "/bzknd/list";
    return await super.get<BzkndModel[]>(url);
  }

  public async getBzkndListOnUsers() {
    const url = process.env.REACT_APP_URL_CO + '/bzknd/list/onUser';
    return await super.get<BzkndModel[]>(url);
  }

  public async getUsersActvLogs() {
    const url = process.env.REACT_APP_URL_CO + '/actvLog/log';
    return await super.get<ActvLogModel[]>(url);
  }

  public async getUsersActvFeeds() {
    const url = process.env.REACT_APP_URL_CO + '/actvLog/feed';
    return await super.get<ActvLogModel[]>(url);
  }

  public saveUserActvLog(data: ActvLogSaveModel) {
    const url = process.env.REACT_APP_URL_CO + '/actvLog/log';
    void super.post(url, data);
  }

  public getAllLogs(data: ActvLogDateModel) {
    const url = process.env.REACT_APP_URL_CO + '/actvLog/allData';
    return super.get<ActvLogModel>(url,data);
  }

  public async getKepcoCustInfos(keyword: string | undefined) {
    const url = process.env.REACT_APP_URL_CO + '/customers';
    if (keyword) {
      return await super.get<KepcoCustInfos[]>(url, { keyword });
    }
    return await super.get<KepcoCustInfos[]>(url);
  }

  public async getKepcoDataByKepcoCustNo(kepcoCustNo: string) {
    const url = process.env.REACT_APP_URL_CO + `/customers/${kepcoCustNo}`;
    return await super.get<KepcoUserData>(url);
  }
}
